import React,{useState,useContext} from 'react'
import {FaBars,FaTimes} from 'react-icons/fa'
import {BiSolidUser} from 'react-icons/bi'
import {menu,menu2} from './sampleData'
import {Link,Route,Routes,useLocation,Navigate} from 'react-router-dom'
import {Landing,SignIn,SignUp,AppPage} from './pages'
import Test from './pages/test'
import { Chart } from './components'



const App = () => {
  
  const token = localStorage.getItem('token')
  
  const [open,setOpen] = useState(false)
  const [open2,setOpen2] = useState(false)
  const [active,setActive] = useState(menu[0].name)
  
  const handleClick = () => {
    setOpen((prev) => !prev)
  }
  const location = useLocation()
  console.log(location.pathname)
  return (
    // Setting up Layout
        <Routes>
            <Route 
            element={<Test/>}
            path='/test' />
            <Route 
            element={<SignIn/>}
            path='/sign-in' />
            <Route 
            element={<SignUp/>}
            path='/sign-up' />
            <Route 
            element={<Landing/>}
            path='/' />
            <Route
            path='/app'
            element={ token ? <AppPage/> : <Navigate to='/sign-in' replace={true}/>}
            />
            
        </Routes>
  )
}

export default App
